<template>
    <div class="vx-flex vx-flex-col-reverse vx-my-4 md:vx-flex-row md:vx-gap-x-8 md:vx-justify-between">
        <div
            class="vx-flex vx-flex-col vx-gap-y-2 sm:vx-flex-row sm:vx-gap-x-2 md:vx-grow"
        >
            <slot name="left"></slot>
        </div>
        <div>
           <slot name="right"></slot>
        </div>
    </div>
</template>

<script setup>
</script>
